import { Modal } from 'antd';

interface PopProps {
    onConfirm?: (params: any) => any;
    onCancel?: () => void;
    title: string;
    subtitle: string;
    showPopup: boolean;
    setShowPopup: (showPopup: boolean) => void;
}


const PopupNotes = ({
    onConfirm,
    onCancel,
    title,
    subtitle,
    showPopup,
    setShowPopup,
}: PopProps) => {

    console.log(onConfirm)

    return (
        <>
            <Modal
                open={showPopup}
                title={title}
                onOk={onConfirm}
                onCancel={() => setShowPopup(false)}
                footer={(_, { OkBtn, CancelBtn }) => (
                <>
                {onCancel && <CancelBtn />}
                    <OkBtn />
                </>
                )}
            >
                <p>{subtitle}</p>
            </Modal>
        </>
    )
}


export default PopupNotes